module.exports = __webpack_public_path__ + "static/media/226-united-states.95cf2213.svg";